module.exports = __webpack_public_path__ + "static/media/ReleaseNotes.69a43938.txt";